import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearCreatedAdmission, updateAdmission } from '../../../../store/actions/admissionsActions'
import { ERROR, SET_SUCCESS } from '../../../../store/types'
import TextField from '../../../../components/elements/form/TextField'
import RadioGroup from '../../../../components/elements/form/RadioGroup'
import SelectField from '../../../../components/elements/form/SelectField'
import DateField from '../../../../components/elements/form/DateField'
import moment from 'moment'
import { Switch } from '@headlessui/react'
import TrashIcon from '../../../../components/elements/icons/TrashIcon'
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import BookmarkIcon from '../../../../components/elements/icons/BookmarkIcon'
import Loader from '../../../../components/elements/Loader'
import DataTable from '../../../../components/elements/DataTable'
import { authHeader, tableHeadersFields, transactionTimeStamp } from '../../../../utils'
import EmptyState from '../../../../components/elements/EmptyState'
import ApplicantTableSnippet from '../../../../components/partials/applications/ApplicantTableSnippet'
import ApplicationStatus from '../../../../components/elements/ApplicationStatus'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchApplications } from '../../../../store/actions/applicationsActions'
import axios from 'axios'

const Admission = () => {
    const dispatch = useDispatch()
    const applicationsSelector = useSelector((state => state.applications))
    const navigate = useNavigate()
    const admissionsSelector = useSelector((state => state.admissions))
    const sessionsSelector = useSelector((state => state.academicSessions))
    const feesSelector = useSelector(state => state.fees)
    const {admissionId} = useParams()

    const requiredDoc = {
        name: "", 
        description: "",
        required: false
    }

    const [admissionPayload, setAdmissionPayload] = useState({
        entryClasses: [],
        requiredDocuments: [
            requiredDoc
        ]
    });
    const [validationErrors, setValidationErrors] = useState({});

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        dispatch(fetchApplications(`admission=${admissionId}`, 1, 10))
        const getOpeningDetails = async () => {
            try {
                const headers = authHeader()
        
                  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/admissions/${admissionId}`, { headers })            
        
                  setAdmissionPayload(response.data.data)
                //   fetchFee(response.data.data.payment.fee)
                setLoading(false)
            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
                setLoading(false)
            }
        }
        getOpeningDetails()


        if(admissionsSelector.updatedAdmission !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'Opening updated successfully!'
            })
            dispatch(clearCreatedAdmission())
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [admissionsSelector.updatedAdmission, dispatch]);

    const validateForm = () => {
        let errors = {}

        if(!admissionPayload.title || admissionPayload.title === '') {
            errors.title = true
        }
        if(!admissionPayload.academicSession || admissionPayload.academicSession === '') {
            errors.academicSession = true
        }
        if(!admissionPayload.type || admissionPayload.type === '') {
            errors.type = true
        }
        if(!admissionPayload.entryClasses || admissionPayload.entryClasses.length === 0) {
            errors.entryClasses = true
        }
        if(requiresFee && (!admissionPayload.fee || admissionPayload.fee === '')) {
            errors.fee = true
        }
        if(!admissionPayload.startDate || admissionPayload.startDate === '') {
            errors.startDate = true
        }
        if(!admissionPayload.endDate || admissionPayload.endDate === '') {
            errors.endDate = true
        }
        admissionPayload.requiredDocuments.forEach((doc, docIndex) => {
            if(!doc.name || doc.name === '') {
                errors[`doc-${docIndex}-name`] = true
            }
            if(!doc.description || doc.description === '') {
                errors[`doc-${docIndex}-desc`] = true
            }
        })

        setValidationErrors(errors)

        return errors
    }

    const pushOpening = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            dispatch(updateAdmission(admissionId, admissionPayload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    const entryClasses = ['BASIC7', 'BASIC8', 'BASIC9', 'SSS1', 'SSS2', 'SSS3']
    const toggleClassSelection = (classOption) => {
        let tempPayload = {...admissionPayload}
        if(tempPayload.entryClasses.includes(classOption)){
            tempPayload.entryClasses.splice(tempPayload.entryClasses.indexOf(classOption), 1)
        } else {
            tempPayload.entryClasses.push(classOption)
        }
        setAdmissionPayload(tempPayload)
    }

    const admissionTypes = [
        {
            label: 'Main',
            value: 'MAIN'
        },
        {
            label: 'Supplementary',
            value: 'SUPPLEMENTARY'
        },
    ]

    const [requiresFee, setRequiresFee] = useState(admissionPayload?.fee ? true : false);

    const addRequiredDocument = () => {
        let tempPayload = {...admissionPayload}
        tempPayload.requiredDocuments.push(requiredDoc)
        setAdmissionPayload(tempPayload)
    }

    const updateRequiredDocument = (docIndex, field, value) => {
        let tempPayload = {...admissionPayload}
        tempPayload.requiredDocuments[docIndex][field] = value
        setAdmissionPayload(tempPayload)
    }
    
    const removeRequiredDocument = (docIndex) => {
        let tempPayload = {...admissionPayload}
        tempPayload.requiredDocuments.splice(docIndex, 1)
        setAdmissionPayload(tempPayload)
    }

    const tableOptions = {
        selectable: false,
        multiselect: false,
        clickableRows: true,
        rowAction: (rowIndex)=>{
          navigate(applicationsSelector.applications.applications[rowIndex]._id)
        }
      }
    
      const columnWidths = {
        applicant: 'w-3/12',
        applicationCode: 'w-2/12',
        class: 'w-1/12',
        parent: 'w-1/12',
        admission: 'w-2/12',
        status: 'w-2/12',
        date: 'w-1/12',
      }
    
      const columnDataStyles = {}
      
      const cleanUpTableData = (array) => {
        if(!array) return
        let finalResult = [] 
        array.forEach((object, objectIndex) => {
            const applicationObject = {
              applicant: <ApplicantTableSnippet applicant={object} />,
              applicationCode: object.applicationCode,
              class: object.class,
              parent: <p>{object.parent.firstName} {object.parent.lastName}</p>,
              admission: object.admission.title,
              status: <ApplicationStatus status={object.status} />,
              date: transactionTimeStamp(object.createdAt).date,
            }
    
            finalResult.push(applicationObject)
        })
        return finalResult
      }

    return (
        <AdministrationLayout pageTitle={`Admissions/Openings`}>
            {loading ?
                <Loader />
                :
                <div className='w-11/12 mx-auto'>
                    <div className='w-full flex justify-between mb-8'>
                        <div>
                            <h3 className='text-lg font-medium'>Opening Details</h3>
                            <p className='text-sm'>You can read and make changes to this opening below, click on "Save updates" when you are done making changes.</p>
                        </div>
                        <div>
                            <button onClick={()=>{pushOpening()}}  className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                                <BookmarkIcon className='w-5 h-5' /> Save Updates
                            </button>
                        </div>
                    </div>
                    <div className='flex items-start gap-x-8'>
                        <div className='w-6/12'>
                            <div className=''>
                                <TextField
                                    inputLabel="Title of opening" 
                                    fieldId="fee-name" 
                                    inputType="text" 
                                    requiredField={true}
                                    preloadValue={admissionPayload.title || ''}
                                    hasError={validationErrors && validationErrors.title} 
                                    returnFieldValue={(value)=>{setAdmissionPayload({...admissionPayload, ...{title: value}})}}
                                />
                            </div>

                            <div className='mt-4'>
                                <RadioGroup 
                                    items={admissionTypes} 
                                    inline={true}
                                    preSelectedIndex={admissionTypes.findIndex(item => item.value === admissionPayload.type)}
                                    inputLabel={'Admission Type'}
                                    requiredField={true}
                                    returnSelected={(value) => {setAdmissionPayload({...admissionPayload, ...{type: value.value}})}} 
                                    hasError={validationErrors && validationErrors.type}  
                                    titleField='label'
                                />
                            </div>

                            {sessionsSelector?.academicSessions?.academicSessions?.length > 0 ? <SelectField
                                    selectOptions={sessionsSelector.academicSessions.academicSessions}
                                    inputLabel="Select academic session"
                                    titleField="name"
                                    displayImage={false}
                                    imageField=""
                                    requiredField={true}
                                    preSelectedIndex={ admissionPayload.academicSession ? 
                                        sessionsSelector.academicSessions.academicSessions.findIndex(item => 
                                        item._id === admissionPayload.academicSession 
                                    ) : ''}
                                    preSelectedLabel="_id"
                                    fieldId="fee-select"
                                    hasError={validationErrors && validationErrors.academicSession}
                                    // return id of accounts of the selected option
                                    returnFieldValue={(value) => {setAdmissionPayload({...admissionPayload, ...{academicSession: value._id}})}}
                                /> 
                                : 
                                <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                                    <p>There are no sessions yet. To be able to choose a session for this opening, please navigate to "Academic sessions" on the left sidebar and create one.</p>
                                </div>
                            }

                            <div className='my-2 w-full'>
                                <DateField
                                    inputLabel="Start Date" 
                                    fieldId="start-date" 
                                    requiredField={true}
                                    inputType="text" 
                                    preloadValue={(moment(admissionPayload.startDate).format('YYYY-MM-DD')) || ''}
                                    hasError={validationErrors && validationErrors.startDate} 
                                    returnFieldValue={(value)=>{
                                        // const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                                        setAdmissionPayload({...admissionPayload, ...{startDate: new Date(value)}})
                                    }}
                                />
                            </div>

                            <div className='my-2 w-full'>
                                <DateField
                                    inputLabel="End Date" 
                                    fieldId="end-date" 
                                    requiredField={true}
                                    inputType="text" 
                                    preloadValue={(moment(admissionPayload.endDate).format('YYYY-MM-DD')) || ''}
                                    hasError={validationErrors && validationErrors.endDate} 
                                    returnFieldValue={(value)=>{
                                        // const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                                        setAdmissionPayload({...admissionPayload, ...{endDate: new Date(value)}})
                                    }}
                                />
                            </div>

                            <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50">
                                <div className='w-10/12'>
                                    <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Requires fee</label>
                                    <label className="text-xs text-gray-500 font-sofia-pro">Flip this switch if this examination requires a fee for entry.</label>
                                </div>
                                <div className='w-2/12 flex flex-row-reverse'>
                                    <Switch
                                        checked={requiresFee}
                                        onChange={()=>{setRequiresFee(!requiresFee)}}
                                        className={`${
                                            requiresFee ? 'bg-accent' : 'bg-gray-400'
                                        } relative inline-flex items-center h-5 rounded-full w-10`}
                                        >
                                        <span className="sr-only">Requires fee</span>
                                        <span
                                            className={`transform transition ease-in-out duration-200 ${
                                                requiresFee ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                            } inline-block w-3 h-3 transform rounded-full`}
                                        />
                                    </Switch>
                                </div>

                            </div>
                            {requiresFee && <div className='mt-4 w-full'>
                                {feesSelector.fees.fees.length > 0 ? <SelectField
                                    selectOptions={feesSelector.fees.fees}
                                    inputLabel="Select fee"
                                    titleField="name"
                                    displayImage={false}
                                    imageField=""
                                    requiredField={true}
                                    preSelectedIndex={ admissionPayload.fee ? 
                                        feesSelector.fees.fees.findIndex(item => 
                                        item._id === admissionPayload.fee 
                                    ) : ''}
                                    preSelectedLabel="_id"
                                    fieldId="fee-select"
                                    hasError={validationErrors && validationErrors.fee}
                                    // return id of accounts of the selected option
                                    returnFieldValue={(value) => {setAdmissionPayload({...admissionPayload, ...{fee: value._id}})}}
                                /> 
                                : 
                                <div className='w-full bg-gray-100 p-4  rounded text-xs text-gray-700 flex items-center justify-center'>
                                    <p>There are no fees yet. To be able to choose a fee for this examination, please navigate to fees on the left sidebar and create a fee.</p>
                                </div>
                                
                            }
                            </div>}

                            <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50">
                                <div className='w-10/12'>
                                    <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Publish this opening</label>
                                    <label className="text-xs text-gray-500 font-sofia-pro">This application will be published/broadcasted if you turn this on </label>
                                </div>
                                <div className='w-2/12 flex flex-row-reverse'>
                                    <Switch
                                        checked={admissionPayload.published}
                                        onChange={
                                            ()=>{
                                                setAdmissionPayload({
                                                    ...admissionPayload, 
                                                    ...{published: !admissionPayload.published}
                                                })
                                            }
                                        }
                                        className={`${
                                            admissionPayload.published ? 'bg-accent' : 'bg-gray-400'
                                        } relative inline-flex items-center h-5 rounded-full w-10`}
                                        >
                                        <span className="sr-only">published</span>
                                        <span
                                            className={`transform transition ease-in-out duration-200 ${
                                                admissionPayload.published ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                            } inline-block w-3 h-3 transform rounded-full`}
                                        />
                                    </Switch>
                                </div>
                            </div>
                            <div className="w-full flex justify-between gap-x-4 mt-4 border-secondary border-opacity-50">
                                <div className='w-10/12'>
                                    <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Set as active</label>
                                    <label className="text-xs text-gray-500 font-sofia-pro">Set this admission as active. If ignored, the admission will only become active at the start date</label>
                                </div>
                                <div className='w-2/12 flex flex-row-reverse'>
                                    <Switch
                                        checked={admissionPayload.active}
                                        onChange={
                                            ()=>{
                                                setAdmissionPayload({
                                                    ...admissionPayload, 
                                                    ...{active: !admissionPayload.active}
                                                })
                                            }
                                        }
                                        className={`${
                                            admissionPayload.active ? 'bg-accent' : 'bg-gray-400'
                                        } relative inline-flex items-center h-5 rounded-full w-10`}
                                        >
                                        <span className="sr-only">active</span>
                                        <span
                                            className={`transform transition ease-in-out duration-200 ${
                                                admissionPayload.active ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                            } inline-block w-3 h-3 transform rounded-full`}
                                        />
                                    </Switch>
                                </div>
                            </div>
                        </div>
                        <div className='w-6/12'>
                            <div className='w-10/12'>
                                <label className={`block text-sm font-medium text-gray-700 font-sofia-pro mt-1 ${validationErrors.entryClasses ? 'text-red-500' : 'text-gray-700'}`}><span className="text-red-500">*</span> Entry Classes</label>
                                <label className="text-xs text-gray-500 font-sofia-pro">Select which classes are available for this opening below.</label>
                            </div>
                            <div className='w-full mt-4'>
                                {entryClasses.map((entryClass, classIndex)=>(
                                    <button onClick={()=>{toggleClassSelection(entryClass)}} className={`px-3 py-1 text-sm rounded mr-4 mb-4 border border-vcm-purple hover:bg-vcm-light-purple transition duration-200 ${admissionPayload.entryClasses.includes(entryClass) ? 'bg-vcm-purple text-purple-200' : 'bg-gray-200 text-vcm-purple'}`} key={classIndex}>{entryClass}</button>
                                ))}
                            </div>
                            <div className='w-full mt-4'>
                                {admissionPayload.requiredDocuments.map((doc, docIndex)=>(
                                    <div key={docIndex}>
                                        <div className="w-full flex items-start justify-between gap-x-4 mt-4 relative">
                                            <div className='w-full'>
                                                <TextField
                                                    inputLabel="Document name" 
                                                    fieldId={`doc-${docIndex}-name`}  
                                                    inputType="text" 
                                                    inputPlaceholder={`The name of the document`}
                                                    requiredField={true}
                                                    preloadValue={doc.name || ''}
                                                    hasError={validationErrors && validationErrors[`doc-${docIndex}-name`]} 
                                                    returnFieldValue={(value)=>{updateRequiredDocument(docIndex, 'name', value)}}
                                                />
                                            </div>
                                            <div className='w-full'>
                                                <TextField
                                                    inputLabel="Description" 
                                                    fieldId={`doc-${docIndex}-desc`} 
                                                    inputType="text" 
                                                    inputPlaceholder={`Short description of the required document`}
                                                    requiredField={true}
                                                    preloadValue={doc.name || ''}
                                                    hasError={validationErrors && validationErrors[`doc-${docIndex}-desc`]} 
                                                    returnFieldValue={(value)=>{updateRequiredDocument(docIndex, 'description', value)}}
                                                />
                                            </div>
                                            {docIndex > 0 && <div className="absolute z-50 -top-[5px] right-0 w-[20px] flex items-center justify-center">
                                                <button onClick={()=>{removeRequiredDocument(docIndex)}} className='p-1 cursor-pointer rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                                    <TrashIcon className={`w-5 h-5`} />
                                                </button>
                                            </div>}
                                        </div>
                                        <div className="w-full flex items-start justify-between gap-x-4 mt-1 relative">
                                            <div className="w-full flex justify-between gap-x-4 mt-1 border-secondary border-opacity-50">
                                                <div className='w-10/12'>
                                                    <label className="block text-sm font-medium text-gray-700 font-sofia-pro">Required</label>
                                                    <label className="text-xs text-gray-500 font-sofia-pro">Flip this switch if this is compulsory.</label>
                                                </div>
                                                <div className='w-2/12 flex flex-row-reverse'>
                                                    <Switch
                                                        checked={doc.required}
                                                        onChange={()=>{updateRequiredDocument(docIndex, 'required', !doc.required)}}
                                                        className={`${
                                                            doc.required ? 'bg-accent' : 'bg-gray-400'
                                                        } relative inline-flex items-center h-5 rounded-full w-10`}
                                                        >
                                                        <span className="sr-only">Requires fee</span>
                                                        <span
                                                            className={`transform transition ease-in-out duration-200 ${
                                                                doc.required ? 'translate-x-6 bg-primary' : 'translate-x-1 bg-gray-600'
                                                            } inline-block w-3 h-3 transform rounded-full`}
                                                        />
                                                    </Switch>
                                                </div>
                                            </div>
                                            <div className='w-full'>
                                                
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className='flex flex-row-reverse mt-4'>
                                    <button onClick={()=>{addRequiredDocument()}} className={`px-3 py-2 text-sm rounded mb-4 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple transition duration-200 bg-vcm-purple text-purple-200`}>Add Required Document</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='w-full flex justify-between mt-12'>
                    <div>
                    <h3 className='text-lg font-medium'>Latest applications for this opening </h3>
                    {/* <p className='text-sm'>The most recent applications to this opening are shown belo</p> */}
                    </div>
                    <div>
                    {/* <Link to={`analytics`}>
                    <button className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                        <PieChartIcon className='w-5 h-5' /> Applications Analytics
                    </button>
                    </Link> */}

                    </div>
                </div>
                    {applicationsSelector.loadingApplications ? 
                        <Loader />
                    :
                    <>
                    {applicationsSelector.applications.applications.length > 0 ? <div className=''>
                        <div className='w-full'>
                        <DataTable
                            tableHeaders={tableHeadersFields(cleanUpTableData(applicationsSelector.applications.applications)[0]).headers} 
                            tableData={cleanUpTableData(applicationsSelector.applications.applications)} 
                            columnWidths={columnWidths}
                            columnDataStyles={columnDataStyles}
                            allFields={tableHeadersFields(cleanUpTableData(applicationsSelector.applications.applications)[0]).fields}
                            onSelectItems={()=>{}}
                            tableOptions={tableOptions}
                            pagination={null}
                            onSelectSingle={()=>{}}
                            changePage={()=>{}}
                            updatePerPage={()=>{}}
                        />

                        <div className='w-4/12 mx-auto mt-6'>
                            <button className='w-full p-4 rounded border border-transparent bg-gray-100 text-gray-500 text-sm transition duration-200 hover:text-gray-800 hover:border-gray-400 '>
                                See all applications for this opening
                            </button>
                        </div>
                        </div>
                        
                    </div>
                        : 
                    <div className='mt-24 w-1/2 mx-auto'>
                        <EmptyState emptyStateText={`There are no applications for this opening yet!`} />
                    </div>

                    }
                    </>
                }
                </div>
            }
        </AdministrationLayout>
    )
}

export default Admission